import React from 'react';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '../../common/Card';
import {convertISODateTimeToBRLocale} from "../../common/Util";

export default ( {ostatus} ) => {

    const NA = 'N/A';

  let xC = (<React.Fragment/>);

  if (ostatus.legadoOrdemServicoSequencia != null) { xC = (
      <ListItem style={{display:'flex', justifyContent:'space-between'}}>
        <Typography  style={{ fontSize: '0.8rem'}}>COLETA:</Typography>
        <Typography style={{ fontSize: '1.3rem'}}>{ostatus.legadoOrdemServicoSequencia}</Typography>
      </ListItem>) }
  let xS = (<React.Fragment/>);
  if (ostatus.legadoPneuFabricante != null) { xS = (
      <ListItem style={{display:'flex', justifyContent:'space-between'}}>
        <Typography  style={{ fontSize: '0.8rem'}}>FABRICANTE:</Typography>
        <Typography style={{ fontSize: '1.3rem'}}>{ostatus.legadoPneuFabricante}</Typography>
      </ListItem>) }
  let xT = (<React.Fragment/>);
    if (ostatus.legadoFaturado !== null && ostatus.legadoFaturado) { xT = (
        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography  style={{ fontSize: '0.8rem', color: 'red'}}>FATURADO:</Typography>
            <Typography style={{ fontSize: '1.3rem'}}>SIM</Typography>
        </ListItem>) }

  return (
    <React.Fragment>
      <Card isCustomStyle>
        <Typography variant="subtitle1" style={{textAlign:"center", fontSize: '1.5rem'}}>ERP</Typography>
        {/*<Typography variant="subtitle1" style={{textAlign:"center", fontSize: '1.5rem'}}>{os}</Typography>*/}

        <List>
          <ListItem  style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>COLETA ATUAL:</Typography>
            <Typography  style={{ fontSize: '1.3rem'}}>{ostatus.legadoOrdemServicoSequencia}</Typography>
          </ListItem>
          <ListItem  style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>FABRICANTE:</Typography>
            <Typography  style={{ fontSize: '1.3rem'}}>{ostatus.legadoPneuFabricante}</Typography>
          </ListItem>
          <ListItem  style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>MODELO:</Typography>
            <Typography style={{ fontSize: '1.3rem'}}>{ostatus.legadoPneuModelo}</Typography>
          </ListItem>
          <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>BANDA | LARGURA:</Typography>
            <Typography  style={{ fontSize: '1.3rem'}}>{ostatus.legadoBanda} | {ostatus.legadoBandaLargura}</Typography>
          </ListItem>

           <ListItem style={{display:'flex', justifyContent:'space-between'}}>
               <Typography style={{ fontSize: '0.8rem'}}>PRODUCAO:</Typography>
               <Typography  style={{ fontSize: '1.3rem'}}> { ostatus.legadoProduzido? "SIM" : "NAO" } - {ostatus.legadoDHProducao? convertISODateTimeToBRLocale(ostatus.legadoDHProducao) : ''}</Typography>
           </ListItem>

            { ostatus.legadoRecusado  &&
                <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                    <Typography style={{ fontSize: '0.8rem'}}>RECUSADO:</Typography>
                    <Typography  style={{ fontSize: '1.3rem'}}> { ostatus.legadoRecusado? "SIM" : "NAO" } </Typography>
                </ListItem>
            }

            <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                <Typography style={{ fontSize: '0.8rem'}}>FATURADO:</Typography>
                <Typography  style={{ fontSize: '1.3rem'}}> { ostatus.legadoFaturado? "SIM" : "NAO" } - {ostatus.legadoDHFaturamento? convertISODateTimeToBRLocale(ostatus.legadoDHFaturamento) : ''}</Typography>
            </ListItem>




            {/*<ListItem style={{display:'flex', justifyContent:'space-between'}}>*/}
            {/*    <Typography style={{ fontSize: '0.6rem'}}>Consulta realizada em 31/5/22. Atualizações a cada 15dias.</Typography>*/}
            {/*</ListItem>*/}
          {/*<ListItem>Atualizado em: {updatedAt}</ListItem>*/}
        </List>
      </Card>
    </React.Fragment>
  )
}
